import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeeLevelFeatureComponent } from './feature/fee-level-feature.component';
import { FeeLevelPresenterComponent } from './presenter/fee-level-presenter.component';
import { FeeLevelDataService } from '../data-services/fee-level';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { EntityDataService } from '@ngrx/data';
import { entityName } from '../data-services/fee-level/fee-level.data-service';
import { FeeLevelRoute } from './fee-level.route';


@NgModule({
  // declarations: [FeeLevelFeatureComponent, FeeLevelPresenterComponent],
  providers: [FeeLevelDataService],
  imports: [
    CommonModule,
    SharedModule,
    UIRouterModule.forChild({
      states: [FeeLevelRoute]
    })
  ]
})
export class FeeLevelModule {
  constructor(
    entityDataService: EntityDataService,
    feeLevelService: FeeLevelDataService
  ) {
    entityDataService.registerService(entityName, feeLevelService);
  }
}
